/* eslint-disable  no-unused-vars */
import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

import { Navigate } from 'react-router-dom';

// helper component to guard routes
const RequireAuth = ({ children }) => {
    const token = localStorage.getItem('club-jwt');
    if (!token) {
        return <Navigate to="/pages/login/login3" replace />;
    }
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp && payload.exp * 1000 < Date.now()) {
            localStorage.removeItem('club-jwt');
            return <Navigate to="/pages/login/login3" replace />;
        }
    } catch (err) {
        // malformed token
        localStorage.removeItem('club-jwt');
        return <Navigate to="/pages/login/login3" replace />;
    }
    return children;
};


// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/clubs/Browse')));

// utilities routing
//const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
//const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
//const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
//const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
//const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
//const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const ClubsBrowse = Loadable(lazy(() => import('views/clubs/Browse')));
const DrawGroups = Loadable(lazy(() => import('views/groups/DrawGroups')));
const Users = Loadable(lazy(() => import('views/users')));
//const CreateTournament = Loadable(lazy(() => import('views/tournaments/CreateTournament')))
//const CreateTimeSlots = Loadable(lazy(() => import('views/tournaments/CreateTimeSlots')))
//const SimulateSubcribers = Loadable(lazy(() => import('views/tournaments/SimulateSubcribers')))
const GamePlanning = Loadable(lazy(() => import('views/gamePlanning')))
//const DrawGameCalendarFullScreen = Loadable(lazy(() => import('views/gamePlanning/DrawGameCalendarFullScreen')))
const GroupsResults = Loadable(lazy(() => import('views/groupsResults')))
const DrawBrackets = Loadable(lazy(() => import('views/playoffs/DrawBrackets')))
const ScheduleRestrictions = Loadable(lazy(() => import('views/scheduleRestrictions')))
const CreateGroups = Loadable(lazy(() => import('views/groups/CreateGroups')))
const CreateGames = Loadable(lazy(() => import('views/groups/CreateGames')))
const GamesRol = Loadable(lazy(() => import('views/groups/GamesRol')))
const CreateReservations = Loadable(lazy(() => import('views/reservations/CreateReservations')))
const PrintableSetups = Loadable(lazy(() => import('views/printableSetups')))
const DrawGameCalendar = Loadable(lazy(() => import('views/gamePlanning/DrawGameCalendar')))
const PointsAwarded = Loadable(lazy(() => import('views/pointsAwarded')))
const WhenDoIPlay = Loadable(lazy(() => import('views/mobile')))
const Reports = Loadable(lazy(() => import('views/reports')))
const CalculatePlayoffs = Loadable(lazy(() => import('views/playoffs/CalculaPlayoffs')))
const ImagesPages = Loadable(lazy(() => import('views/images')))
const LandingPage = Loadable(lazy(() => import('views/landingPage/LandingPage')))
const AccountInfoPage = Loadable(lazy(() => import('views/account/AccountInfoPage')))
const CreateEventPage = Loadable(lazy(() => import('views/events/CreateEventPage')))
const AddMoreTimeSlots = Loadable(lazy(() => import('views/tournaments/AddMoreTimeSlots')))
const Categories = Loadable(lazy(() => import('views/categories/Categories')))
const UploadTeamsCSV = Loadable(lazy(() => import('views/teams/UploadTeamsCSV')))
const TeamsList = Loadable(lazy(() => import('views/teams/TeamsList')))
const TournamentCalculatorForm = Loadable(lazy(() => import('views/tournaments/TournamentCalculatorForm')))
const TournamentPaymentsList = Loadable(lazy(() => import('views/teams/TournamentPaymentsList')))
const TimeRestrictionsComponent = Loadable(lazy(() => import('views/teams/TimeRestrictionsComponent')))
const InstitutionalPlayers = Loadable(lazy(() => import('views/institutionalPlayers')))
const AssignRoundsToGames = Loadable(lazy(() => import('views/groups/AssignRoundsToGames')))
const GamesRolbyRounds = Loadable(lazy(() => import('views/groups/GamesRolbyRounds')))
const Test = Loadable(lazy(() => import('views/test')))



// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <RequireAuth><MainLayout /></RequireAuth>,
    children: [
        {
            path: '/',
            element: <LandingPage />
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <DashboardDefault />
                }
            ]
        },
/*         {
            path: 'utils',
            children: [
                {
                    path: 'util-typography',
                    element: <UtilsTypography />
                }
            ]
        }, */
/*         {
            path: 'utils',
            children: [
                {
                    path: 'util-color',
                    element: <UtilsColor />
                }
            ]
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-shadow',
                    element: <UtilsShadow />
                }
            ]
        },
        {
            path: 'icons',
            children: [
                {
                    path: 'tabler-icons',
                    element: <UtilsTablerIcons />
                }
            ]
        },
        {
            path: 'icons',
            children: [
                {
                    path: 'material-icons',
                    element: <UtilsMaterialIcons />
                }
            ]
        },
 *//*         {
            path: 'sample-page',
            element: <SamplePage />
        }, */
        {
            path: 'views/clubs/Browse',
            element: <ClubsBrowse />
        },
        {
            path: 'views/groups/Draw',
            element: <DrawGroups />
        },
        {
            path: 'views/users',
            element: <Users />
        },
/*         {
            path: 'views/tournament/createtournament',
            element: <CreateTournament />
        },  */
/*         {
            path: 'views/tournament/simulatesubscribers',
            element: <SimulateSubcribers />
        }, */
        {
            path: 'views/tournament/creategroups',
            element: <CreateGroups />
        },
        {
            path: 'views/roundrobinwinner',
            element: <GroupsResults />
        },
        {
            path: 'views/playoffs/drawbrackets',
            element: <DrawBrackets />
        },
        {
            path: '/views/groups/creategames',
            element: <CreateGames />
        },
        // Game Planning
        {
            path: '/views/gameplanning/restrictions',
            element: <ScheduleRestrictions />
        },
        {
            path: 'views/gameplanning',
            element: <GamePlanning />
        },
        {
            path: '/views/gameplanning/drawgamecalendar',
            element: <DrawGameCalendar />
        },
        {
            path: '/views/gameplanning/gamesrol',
            element: <GamesRol />
        },
        {
            path: '/views/gameplanning/gamesrolbyrounds',
            element: <GamesRolbyRounds />       
        },
        {
            path: '/views/gameplanning/whendoiplay',
            element: <WhenDoIPlay />
        },
        {
            path: '/views/createreservations',
            element: <CreateReservations />
        },
        {
            path: '/views/printablesetup',
            element: <PrintableSetups />
        },
        {
            path: '/views/pointsawarded',
            element: <PointsAwarded />
        },
        {
            path: '/views/reports',
            element: <Reports />
        },
        {
            path: '/views/calculateplayoffs',
            element: <CalculatePlayoffs />
        },
        {
            path: '/views/images',
            element: <ImagesPages />
        },
    
        {
            path: '/views/account-info',
            element: <AccountInfoPage />
        }, 
        {
            path: '/views/tournament/createevent',
            element: <CreateEventPage />
        },
        {
            path: '/views/tournament/addmoretimeslots',
            element: <AddMoreTimeSlots />
        },
        {
            path: '/views/categories',
            element: <Categories />
        },
        {
            path: '/views/uploadteamscsv',
            element: <UploadTeamsCSV />
        },
        {
            path: '/views/TEAMSLIST',
            element: <TeamsList />
        },
        {
            path: '/views/tournamentcalculatorform',
            element: <TournamentCalculatorForm />
        },
        {
            path: '/views/timerestrictions',
            element: <TimeRestrictionsComponent />
        },
        {
            path: '/views/listpayments',
            element: <TournamentPaymentsList />
        },
        {
            path:'/views/institutionalplayers',
            element:<InstitutionalPlayers />

        },
        {
            path: '/views/assignroundstogames',
            element: <AssignRoundsToGames />
        },
    ]
};

export default MainRoutes;
